import { render, staticRenderFns } from "./ExpansionPanel.vue?vue&type=template&id=dccdb49c&scoped=true"
import script from "./ExpansionPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExpansionPanel.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ExpansionPanel.vue?vue&type=style&index=0&id=dccdb49c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dccdb49c",
  null
  
)

export default component.exports